import { buildVueDompurifyHTMLDirective } from 'vue-dompurify-html'

export const vSafeHtml = buildVueDompurifyHTMLDirective({
  hooks: {
    afterSanitizeAttributes: (node) => {
      if (node.tagName === 'IMG') {
        node.setAttribute('referrerpolicy', 'no-referrer')
      }
    },
  },
})
